import 'ant-design-vue/lib/style/index.less' // antd core styles
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './global.scss' // app & third-party component styles

import Vue from 'vue'
import vSelect from 'vue-select'
import VuePageTitle from 'vue-page-title'
import NProgress from 'vue-nprogress'
import VueLayers from 'vuelayers'
import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './localization'
import './antd'
import './registerServiceWorker'

import cognitoDriver from './cognito/indexDriver'
import cognito from './cognito/'

import VueApollo from 'vue-apollo'
import apolloClient from './apolloClient'
// mocking api
import './services/axios/fakeApi'

import Vuelidate from 'vuelidate'

import VueHtml2Canvas from 'vue-html2canvas'

import 'vue-select/dist/vue-select.css'

import 'vue-select/src/scss/vue-select.scss'

Vue.use(Vuelidate)
Vue.use(VueApollo)
Vue.use(BootstrapVue)
Vue.use(VueLayers)
Vue.use(VueHtml2Canvas)

Vue.component('v-select', vSelect)

Vue.use(NProgress)
Vue.use(VuePageTitle, {
  prefix: 'Administrador |',
  router,
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
  },
})

Vue.config.productionTip = false
const nprogress = new NProgress({ parent: 'body' })

new Vue({
  router,
  store,
  nprogress,
  i18n,
  cognitoDriver,
  cognito,
  apolloProvider,
  beforeCreate() {
    this.$store.subscribe((mutation, state) => {
      // console.log(mutation)
      // console.log(state)
      if (mutation.type === 'ADD_NOTIFICATION' || mutation.type === 'DELETE_NOTIFICATION') {
        // console.log()
        // console.log(state.notifications)
        localStorage.setItem('store', JSON.stringify(state.notifications))
      }
    })
    this.$store.commit('INITIAL_STORE')
  },
  render: h => h(App),
}).$mount('#app')
